module.exports = __webpack_public_path__ + "img/user.788352a7.png";